import { Hanko } from '@teamhanko/hanko-frontend-sdk';
import { getToken } from './auth';

const HANKO_API_URL =
  import.meta.env.VITE_HANKO_API_URL || 'https://auth.cloudunifi.com';

// The SDK reads the session token from sessionStorage under a key equal to its
// `cookieName` option (default "hanko") when sessionTokenLocation is sessionStorage.
const SDK_SESSION_KEY = 'hanko';

/**
 * Build a Hanko SDK client authenticated with the JWT the portal already holds.
 *
 * The portal receives the Hanko session token via the login redirect and stores
 * it in localStorage (`hanko_jwt`). The Hanko cookie that the SDK would normally
 * read is HttpOnly and scoped to the login origin, so on portal.cloudunifi.com
 * the SDK has no readable credential and every request 401s. We instead run the
 * SDK in sessionStorage mode and seed it with our stored token, so requests carry
 * `Authorization: Bearer <token>` (accepted because Hanko has
 * enable_auth_token_header enabled).
 */
export function createHankoClient(): Hanko {
  const token = getToken();
  if (token) {
    sessionStorage.setItem(SDK_SESSION_KEY, token);
  } else {
    // Avoid sending a stale token left over from a previous session.
    sessionStorage.removeItem(SDK_SESSION_KEY);
  }
  return new Hanko(HANKO_API_URL, { sessionTokenLocation: 'sessionStorage' });
}
